/*
 * @Descripttion:
 * @version:
 * @Author: Francis
 * @Date: 2022-07-26 22:13:19
 * @LastEditors: Francis
 * @LastEditTime: 2022-08-02 14:02:50
 */
import Vue from "vue";
import Router from "vue-router";
import store from "../store/index";
import { Toast } from "vant";

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: "/",
      redirect: "/loadingPage",
    },
    {
      path: "/loadingPage",
      component: () => import("@/views/loadingPage/index"),
      meta: {
        title: "加载中",
      },
    },
    // pallets 会计
    {
      path: "/accountant/business",
      component: () => import("@/views/accountant/business"),
      meta: {
        title: "业务计划",
        needLogin: true,
        role: "2",
      },
    },
    {
      path: "/accountant/release",
      component: () => import("@/views/accountant/release"),
      meta: {
        title: "发布货源",
        needLogin: true,
        role: "2",
      },
    },
    {
      path: "/accountant/release/add",
      component: () => import("@/views/accountant/release/add"),
      meta: {
        title: "发布货源",
        needLogin: true,
        role: "2",
      },
    },
    // dispatch 调度
    {
      path: "/dispatch/business",
      component: () => import("@/views/dispatch/business"),
      meta: {
        title: "业务计划",
        needLogin: true,
        role: "1",
      },
    },
    {
      path: "/dispatch/business/indo",
      component: () => import("@/views/dispatch/business/infopa"),
      meta: {
        title: "业务详情",
        needLogin: true,
        role: "1",
      },
    },
    {
      path: "/dispatch/toExamine",
      component: () => import("@/views/dispatch/toExamine"),
      meta: {
        title: "审核",
        needLogin: true,
        role: "1",
      },
    },
    {
      path: "/dispatch/toExamine/identity",
      component: () => import("@/views/dispatch/toExamine/identity"),
      meta: {
        title: "身份认证",
        needLogin: true,
        role: "1",
      },
    },
    {
      path: "/dispatch/toExamine/identityExamine",
      component: () => import("@/views/dispatch/toExamine/identityExamine"),
      meta: {
        title: "身份认证审核",
        needLogin: true,
        role: "1",
      },
    },
    {
      path: "/dispatch/toExamine/shipowner",
      component: () => import("@/views/dispatch/toExamine/shipowner"),
      meta: {
        title: "船只审核列表",
        needLogin: true,
        role: "1",
      },
    },
    {
      path: "/dispatch/toExamine/toExamine",
      component: () => import("@/views/dispatch/toExamine/toExamine"),
      meta: {
        title: "船只审核",
        needLogin: true,
        role: "1",
      },
    },
    {
      path: "/dispatch/business/add",
      component: () => import("@/views/dispatch/business/add"),
      meta: {
        title: "新增业务",
        needLogin: true,
        role: "1",
      },
    },
    {
      path: "/dispatch/order",
      component: () => import("@/views/dispatch/order"),
      meta: {
        title: "工单调度",
        needLogin: true,
        role: "5",
      },
    },
    {
      path: "/dispatch/order/replacement",
      component: () => import("@/views/dispatch/order/replacement"),
      meta: {
        title: "工单调度",
        needLogin: true,
        role: "5",
      },
    },
    // audit 审核
    {
      path: "/audit/parts",
      component: () => import("@/views/audit/parts"),
      meta: {
        title: "配件",
        needLogin: true,
        role: "4",
      },
    },
    {
      path: "/audit/work",
      component: () => import("@/views/audit/work"),
      meta: {
        title: "工单",
        needLogin: true,
        role: "4",
      },
    },
    // workOrder 安装
    {
      path: "/workOrder/order",
      component: () => import("@/views/workOrder/order"),
      meta: {
        title: "安装",
        needLogin: true,
        role: "3,5",
        keepAlive: true,
      },
    },
    {
      path: "/workOrder/order/detail",
      name: "orderDetail",
      component: () => import("@/views/workOrder/order/detail"),
      meta: {
        title: "工单详情",
        needLogin: true,
        role: "3,5",
      },
    },
    {
      path: "/workOrder/parts",
      component: () => import("@/views/workOrder/parts"),
      meta: {
        title: "配件",
        needLogin: true,
        role: "3,5",
      },
    },
    {
      path: "/workOrder/parts/add",
      component: () => import("@/views/workOrder/parts/add"),
      meta: {
        title: "新增核销申请",
        needLogin: true,
        role: "3,5",
      },
    },
    {
      path: "/workOrder/repair",
      component: () => import("@/views/workOrder/repair"),
      meta: {
        title: "维修",
        needLogin: true,
        role: "3,5",
      },
    },
    {
      path: "/workOrder/repair/register",
      component: () => import("@/views/workOrder/repair/register"),
      meta: {
        title: "维修登记",
        needLogin: true,
        role: "3,5",
      },
    },
    {
      path: "/workOrder/repair/registerInfo",
      component: () => import("@/views/workOrder/repair/registerInfo"),
      meta: {
        title: "查看",
        needLogin: true,
        role: "3,5",
      },
    },
    //欣港工单管理
    {
      path: "/generateWorkOrder",
      component: () => import("@/views/xingang/generateWorkOrder"),
      meta: {
        title: "欣港工单",
        needLogin: true,
        role: "6",
        keepAlive: true,
      },
    },
    // 我的
    {
      path: "/my",
      component: () => import("@/views/my/index"),
      meta: {
        title: "我的",
        needLogin: true,
        role: "1,2,3,4,5,6",
      },
    },
    // 我的库存  安装
    {
      path: "/stockc",
      component: () => import("@/views/my/stockc"),
      meta: {
        title: "库存",
        needLogin: true,
        role: "3,5",
      },
    },
    // 通用页查询船只信息
    {
      path: "/shipInquiry",
      component: () => import("@/views/shipInquiry/index"),
      meta: {
        title: "船只信息",
        needLogin: true,
        role: "1,2,3,4,5",
      },
    },
    {
      path: "/login",
      component: () => import("@/views/login/index"),
      meta: {
        title: "登陆",
      },
    },

    {
      path: "*",
      component: () => import("@/components/NotFound"),
    },
  ],
});

router.beforeEach((to, from, next) => {
  let { title, needLogin, role } = to.meta;
  let userRole = localStorage.getItem("role");
  document.title = title;
  if (needLogin && !userRole) {
    Toast.fail("您还未登陆，正在为您跳转。。。");
    next({
      path: "/login",
    });
  } else if (role && role.indexOf(userRole) < 0 && needLogin) {
    Toast.fail("您无权访问当前页面");
    next({
      path: from ? from.path : "/loadingPage",
    });
  } else {
    next();
  }
});

export default router;
